import React, {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";

export const LayoutContext = createContext(null);

export const LayoutProvider = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const toggleNavbar = () => {
        setIsCollapsed(prev => !prev);
    };

    const closeNavbar = () => {
        setIsCollapsed(true);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isMobile) {
            setIsCollapsed(true);
        }
    }, [isMobile]);

    return (
        <LayoutContext.Provider
            value={{
                isCollapsed,
                toggleNavbar,
                closeNavbar,
                isMobile,
            }}
        >
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => {
    const ctx = useContext(LayoutContext);
    if (!ctx) {
        throw new Error("useLayout must be used inside LayoutProvider");
    }
    return ctx;
};
